var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 54,
    viewBox: "0 0 46 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_19455_13694",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 27C0 12.0883 12.0883 0 27 0H46V54H27C12.0883 54 0 41.9117 0 27Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 27C0 12.0883 12.0883 0 27 0H46V54H27C12.0883 54 0 41.9117 0 27Z",
    fill: "#A9CF3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H46H0ZM46 54H0H46ZM0 54V0V54ZM47 0V54H45V0H47Z",
    fill: "#8CAE2B",
    mask: "url(#path-1-inside-1_19455_13694)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7803 32.2803C25.5141 32.5466 25.0974 32.5708 24.8038 32.3529L24.7197 32.2803L19.7197 27.2803C19.4534 27.0141 19.4292 26.5974 19.6471 26.3038L19.7197 26.2197L24.7197 21.2197C25.0126 20.9268 25.4874 20.9268 25.7803 21.2197C26.0466 21.4859 26.0708 21.9026 25.8529 22.1962L25.7803 22.2803L21.311 26.75L25.7803 31.2197C26.0466 31.4859 26.0708 31.9026 25.8529 32.1962L25.7803 32.2803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.b4cb650fab297f174f2b05a8b2578772.svg";
export { ForwardRef as ReactComponent };